module.exports = __webpack_public_path__ + "static/media/pricing.dc138ac0.txt";